import React from 'react';
import Dashboard from '../Dashboard';

function App(props) {
  return (
    <Dashboard {...props}/>
  );
}

export default App;
